import React from 'react';
import {withCacheBust} from '../../../lib/cacheBust';

interface Props {
  src: string;
  alt: string;
  size: IconSize;
}

export enum IconSize {
  SMALL = 24,
  MEDIUM = 30,
  LARGE = 48
}

export const ObjectIcon: React.FC<Props> = ({src, alt, size}: Props) => {
  return (
    <img height={size} width={size} src={withCacheBust(src)} alt={alt} title={alt} />
  );
};
